import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface ModuleHomeItem {
  title: string;
  icon: string;
  link: string;
}

/**
 * Grid de cards de navegação no padrão Peças Basic V2.
 */
@Component({
  selector: 'ngx-module-home-grid',
  templateUrl: './module-home-grid.component.html',
  styleUrls: ['./module-home-grid.component.scss'],
})
export class ModuleHomeGridComponent {

  @Input() pageTitle = '';
  @Input() headerIcon = 'grid-outline';
  @Input() introTitle = 'Selecione uma opção';
  @Input() introText = 'Escolha uma funcionalidade para continuar';
  @Input() items: ModuleHomeItem[] = [];
  @Input() layout: 'default' | 'compact' = 'default';

  constructor(private router: Router) {}

  /**
   * Navega para a rota do item selecionado.
   * @param item - Item de menu com link
   */
  navigate(item: ModuleHomeItem): void {
    if (item?.link) {
      this.router.navigate([item.link]);
    }
  }

  trackByTitle(_index: number, item: ModuleHomeItem): string {
    return item.title + item.link;
  }
}
